import {version} from '../../../package.json'

const globals = {
  logged: false,
  version
}

export default globals
